import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';

import { rootSiteSelector } from 'selectors/root-site';
import CustomHomePage from 'components/custom-home-page';
import SkeletonLayout from 'components/skeleton-layout';

const StandardHomePage = React.lazy(() => import('components/standard-home-page'));

const HomePage = () => {
  const { homePage, loading } = useSelector(rootSiteSelector);

  return loading ? (
    <SkeletonLayout showFooter={false} showHeader={false} />
  ) : homePage ? (
    <CustomHomePage {...homePage} />
  ) : (
    <Suspense fallback={<SkeletonLayout showFooter={false} showHeader={false} />}>
      <StandardHomePage />
    </Suspense>
  );
};

export default HomePage;
